import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import axios from "axios";
export var SITE_SETTINGS_FAILED = new Error("SITE_SETTINGS_FAILED");
export var LOGIN_FAILED = new Error("LOGIN_FAILED");
export var PAYMENT_CODE_INVALID = new Error("PAYMENT_CODE_INVALID");
export var PAYMENT_CODE_CHECK_PAID = new Error("PAYMENT_CODE_CHECK_PAID");
export var PAYMENT_CODE_CHECK_CLOSED = new Error("PAYMENT_CODE_CHECK_CLOSED");
export var PAYMENT_CODE_GENERIC_ERROR = new Error("PAYMENT_CODE_GENERIC_ERROR");
export var ErrorResponse = /*#__PURE__*/function (_Error) {
  _inherits(ErrorResponse, _Error);

  var _super = _createSuper(ErrorResponse);

  function ErrorResponse(errObj) {
    var _this;

    _classCallCheck(this, ErrorResponse);

    _this = _super.call(this, null);

    _defineProperty(_assertThisInitialized(_this), "errorResponse", void 0);

    _this.errorResponse = errObj;
    return _this;
  }

  return ErrorResponse;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var APIErrorResponse = /*#__PURE__*/function (_Error2) {
  _inherits(APIErrorResponse, _Error2);

  var _super2 = _createSuper(APIErrorResponse);

  function APIErrorResponse(errObj) {
    var _this2;

    _classCallCheck(this, APIErrorResponse);

    _this2 = _super2.call(this, null);

    _defineProperty(_assertThisInitialized(_this2), "config", void 0);

    _defineProperty(_assertThisInitialized(_this2), "request", void 0);

    _defineProperty(_assertThisInitialized(_this2), "response", void 0);

    _this2.config = errObj.config;
    _this2.request = errObj.request;
    _this2.response = errObj.response;
    return _this2;
  }

  return APIErrorResponse;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function isInterfaceIAPIError(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj.errors) !== undefined;
}

export var UIError = function UIError(data) {
  _classCallCheck(this, UIError);

  _defineProperty(this, "errors", void 0);

  if (axios.isAxiosError(data)) {
    var _data$response$data$e, _data$response, _data$response$data, _errors$map;

    var errors = (_data$response$data$e = data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : _data$response$data.errors) !== null && _data$response$data$e !== void 0 ? _data$response$data$e : [];
    this.errors = errors === null || errors === void 0 ? void 0 : (_errors$map = errors.map) === null || _errors$map === void 0 ? void 0 : _errors$map.call(errors, function (err) {
      return {
        title: "Unexpected Error",
        message: err === null || err === void 0 ? void 0 : err.errorMessage,
        code: err === null || err === void 0 ? void 0 : err.errorCode
      };
    });
  } else if (isInterfaceIAPIError(data)) {
    var _data$errors, _data$errors$map;

    this.errors = data === null || data === void 0 ? void 0 : (_data$errors = data.errors) === null || _data$errors === void 0 ? void 0 : (_data$errors$map = _data$errors.map) === null || _data$errors$map === void 0 ? void 0 : _data$errors$map.call(_data$errors, function (err) {
      return {
        title: "Unexpected Error",
        message: err === null || err === void 0 ? void 0 : err.errorMessage,
        code: err === null || err === void 0 ? void 0 : err.errorCode
      };
    });
  } else {
    this.errors = [{
      title: "Unexpected Error",
      message: data === null || data === void 0 ? void 0 : data.message
    }];
  }
};